import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const StickyModalButton = () => {
  const [show, setShow] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove error while typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Validate form
  const validateForm = () => {
    let newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Please enter your Full Name.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your Email Address.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid Email Address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter your Phone Number.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone Number must be exactly 10 digits.";
    }

    if (!formData.city.trim()) {
      newErrors.city = "Please enter your City.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Please enter your Message.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Form submit
  const handleSubmit = (e) => {
    if (!validateForm()) {
      e.preventDefault(); // Stop form submission
    }
  };

  return (
    <>
      {/* Sticky Button */}
      <Button
        variant="primary"
        className="sticky-btn"
        onClick={handleOpen}
      >
        Enquire Now
      </Button>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal-800 franchise enq"
      >
        <Modal.Header closeButton>
          <Modal.Title>Enquire Now</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form
            action="https://theroyalchitran.co.in/mail/submit2.php"
            method="POST"
            onSubmit={handleSubmit}
          >
            <div className="row">

              {/* Full Name */}
              <div className="col-lg-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  placeholder="Enter your Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                {errors.fullName && (
                  <small className="text-danger">{errors.fullName}</small>
                )}
              </div>

              {/* Email */}
              <div className="col-lg-6 mb-3">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Enter your Email Address"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>

              {/* Phone */}
              <div className="col-lg-6 mb-3">
                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  placeholder="Enter your Phone Number"
                  maxLength={10}
                  value={formData.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setFormData({
                      ...formData,
                      phone: value,
                    });

                    setErrors({
                      ...errors,
                      phone: "",
                    });
                  }}
                />
                {errors.phone && (
                  <small className="text-danger">{errors.phone}</small>
                )}
              </div>

              {/* City */}
              <div className="col-lg-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  placeholder="Enter your City"
                  value={formData.city}
                  onChange={handleChange}
                />
                {errors.city && (
                  <small className="text-danger">{errors.city}</small>
                )}
              </div>

              {/* Message */}
              <div className="col-lg-12 mb-3">
                <textarea
                  rows="4"
                  className="form-control"
                  name="message"
                  placeholder="Send Message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                {errors.message && (
                  <small className="text-danger">{errors.message}</small>
                )}
              </div>

              {/* Submit */}
              <div className="col-lg-12">
                <button
                  type="submit"
                  className="btn btn-primary w-100 sub"
                >
                  Submit
                </button>
              </div>

            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StickyModalButton;